document.addEventListener('DOMContentLoaded',function (){

    //<!----- Product Page Gallery Image Code Start ----->//
  
  const buttons = document.querySelectorAll(
    ".product-gallery__thumbnail-scroller .product-gallery__thumbnail"
  );
  const Images = document.querySelectorAll(
    ".product-gallery__carousel .product-gallery__media"
  );

  if (!Images.length) return;

  function showByMediaId(itemId) {
    Images.forEach((img) => {
      const media_ID = img.getAttribute("data-media-id");
      if (itemId === media_ID) {
        img.style.display = "block";
      } else {
        img.style.display = "none";
      }
    });
  }

  buttons.forEach((item) => {
    item.addEventListener("click", function () {
      const itemId = this.getAttribute("data-media-id");
      showByMediaId(itemId);
    });
  });

  const prevBtn = document.getElementById("galleryPrev");
  const nextBtn = document.getElementById("galleryNext");

  function getCurrentIndex() {
    let current = -1;
    Images.forEach((img, i) => {
      const style = window.getComputedStyle(img);
      if (style.display !== "none" && !img.hasAttribute("hidden")) {
        current = i;
      }
    });
    if (current === -1) current = 0;
    return current;
  }

  function showByIndex(index) {
    const target = Images[index];
    if (!target) return;
    const itemId = target.getAttribute("data-media-id");
    showByMediaId(itemId);
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      let current = getCurrentIndex();
      let newIndex = current - 1;
      if (newIndex < 0) newIndex = Images.length - 1; // loop
      showByIndex(newIndex);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      let current = getCurrentIndex();
      let newIndex = current + 1;
      if (newIndex >= Images.length) newIndex = 0; // loop
      showByIndex(newIndex);
    });
  }
  
//<!----- Product Page Gallery Image Code End ----->//


  // -------------------- Add on product js start -------------------- 
  let addonProduct = document.querySelector('.addon-cart');
  if(addonProduct){
    addonProduct.addEventListener('click',function (){
      let addonId = addonProduct.dataset.bundleVariant;
      let formData = {
        'items': [{
          'id': addonId,
        }]
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(response => response.json())
        .then(data)
        .catch(error => console.error('Error:', error));
    })
  }

    // -------------------- product page cart button price update start -------------------- 

    const productCartBtn = document.querySelector('.product-info__block-item .itg-proButton');
    const productQuantityInput = document.querySelector('.product-info__block-item .quantity-selector__input-wrapper input');
    const productQtyBtns = document.querySelector('.product-info__block-item .quantity-selector');
    const productCartBtnPrice = Number(productCartBtn.dataset.price);
    const productCartBtnPriceEl = productCartBtn.querySelector('.itg_priceUpdate');
    
    const updatePrice = () => {
      const totalPrice = Number(productQuantityInput.value) * productCartBtnPrice;
      productCartBtnPriceEl.innerText = totalPrice.toFixed(2);
    };
    
    productQuantityInput.addEventListener('input', updatePrice);
    productQtyBtns.addEventListener('click', (e) => {
      if (e.target.closest('.quantity-selector__button, .icon')) updatePrice();
    }); 
  

   //  Quantity in cart page

   const cartQtyLabel = document.querySelector('.product-info__block-item .cartQtyLabel');

  function reloadElement() {
      setTimeout(() => {
        if(cartQtyLabel){
          fetch(window.location.href)
          .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then(data => {
            const newContent = new DOMParser()
              .parseFromString(data, 'text/html')
              .querySelector('.cartQtyLabel');
            
            if (newContent) {
              cartQtyLabel.innerHTML = newContent.innerHTML;
              console.log(newContent)
              console.log('Updated content:', newContent.innerHTML);
            } else {
              console.warn('No element with class .cartQtyLabel found in fetched content.');
            }
          })
          .catch(error => console.error('Error loading content:', error));
        }
      },1000)
    }

  if (productCartBtn) {
    productCartBtn.addEventListener('click',reloadElement);
  }
    document.addEventListener('click', (e) => {
      let proURL = window.location.href;
      let cartProHandleMatch = e.target.closest('.rebuy-cart__flyout-item-info')?.querySelector('.rebuy-cart__flyout-item-product-title')?.href;
      if (e.target.closest('.rebuy-cart__flyout-item-info') && proURL.includes(cartProHandleMatch)) {
        reloadElement();
      }
      if (e.target.closest('.rebuy-cart__flyout-item-remove') && cartQtyLabel && proURL.includes(cartProHandleMatch)) {
        cartQtyLabel.innerHTML = 0;
      }
    });
});

document.onclick = function(event) {
   const priceList = document.querySelector('.price-list--product');
  if (!priceList) return;

  const subscriptionLabel = event.target.closest('label.subscription-radio');
  const onetimeLabel = event.target.closest('label.onetime-radio');

  if (subscriptionLabel) {
    priceList.style.display = 'none';
  } else if (onetimeLabel) {
    priceList.style.display = 'flex';
  }
};

window.addEventListener('load', function() {
  const activeSubscription = document.querySelector('.rc-radio--active.subscription-radio');
  const priceList = document.querySelector('.price-list--product');
  if (!priceList) return;
  if (activeSubscription) {
    priceList.style.display = 'none';
  } else {
    priceList.style.display = 'flex';
  }
});
